import { useEffect, useRef } from "react";

export const useOrderRealtimeSync = ({
      id,
      notifications,
      getData, engine
}: {
      id: string | number | undefined;
      notifications: any;
      getData: () => void;
      engine: any
}) =>
{
      const lastNotifIdRef = useRef<string | number | null>(null);
      const refreshTimeoutRef = useRef<any>(null);

      // debounce refresh
      const triggerRefresh = () =>
      {
            if (refreshTimeoutRef.current)
            {
                  clearTimeout(refreshTimeoutRef.current);
            }

            refreshTimeoutRef.current = setTimeout(() =>
            {
                  getData();
            }, 800); // debounce 0.8s
      };

      // socket / redux notification sync
      useEffect(() =>
      {
            if (!notifications?.length) return;

            const latestNotif = notifications[0];
            if (!latestNotif) return;

            // tránh duplicate event
            if (lastNotifIdRef.current === latestNotif.id) return;
            lastNotifIdRef.current = latestNotif.id;

            const tags: string[] = latestNotif?.tags || [];

            const isRelated = tags.some((tag) =>
                  tag.includes(`order/management-tasking/${id}`)
            );

            if (isRelated)
            {
                  triggerRefresh();
            }
      }, [notifications, id]);

      //  fallback polling chống socket delay
      useEffect(() =>
      {
            if (!id || !engine) return;

            const interval = setInterval(() =>
            {
                  getData();
            }, 300000); // 60s fallback sync

            return () => clearInterval(interval);
      }, [id, engine]);

      return null;
};